
import React, { useEffect, useState } from 'react'
import { Form, Select, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Cards } from '../../components/cards/frame/cards-frame'
import { Main } from '../styled'
import config from '../../config/config';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Modal, notification, Button } from 'antd';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { ProjectHeader } from '../project/style';
import { PageHeader } from '../../components/page-headers/page-headers';
import CreateMerchant from './CreateMerchant';
import EditMerchant from './EditMerchant'

function ManageMerchant() {

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [getSEOData, setSEOnata] = useState([])
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [UId, setId] = useState(null);

  const [deliverystatus, setDeliveryStatus] = useState("");

  const [paginationMerchant, setPaginationMerchant] = useState({ current: 1, pageSize: 10, total: 0 });

  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalMerchantFetched, setTotalMerchantFetched] = useState(false);
  const [userSearchData, setUserSearchdata] = useState([])


  const UID = useSelector((state) => {
    return state.fb.auth.uid;
  });

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    fetchData(paginationMerchant.current, paginationMerchant.pageSize, "Merchant", false, '');
    setId(null)
    setEditData(null)
    setIsEditModalVisible(false);
    setIsModalVisible(false);
    
  };

  useEffect(() => {
    fetchData(paginationMerchant.current, paginationMerchant.pageSize, "Merchant", true, '');
  }, []);

  const fetchData = async (page, pageSize, i_am, fetchTotal = false, searchValue) => {
    try {

      setLoading(true);
      const offset = (page - 1) * pageSize;

      const response = await axios.get(`${config.apiUrl}/userslist`, {
        params: { offset, limit: pageSize, i_am: i_am, searchValue: searchValue, fetchTotal }
      });

      const users = response.data.users;

      const totalRecords = fetchTotal ? response.data.total : paginationMerchant.total;
      setPaginationMerchant({ current: page, pageSize, total: totalRecords });
      if (fetchTotal) {
        setTotalMerchantFetched(true);
      }
      setUserSearchdata(users);

    } catch (error) {
      // Handle error
    } finally {
      setLoading(false);
    }
  };

  const openModal = () => {
    setIsModalVisible(true);
  };

  const showDeleteModal = (uid, logo, i_am) => {
    let image_url = JSON.parse(logo);
    var profile = null;
    if (image_url != null && image_url[0]) {
      profile = image_url[0].url;
    }

    Modal.confirm({
      title: 'Delete user',
      content: (
        <div>
          <p>Do you want to delete user ?</p>
        </div>
      ),
      onOk() {

        let post_data = { uid: uid, image_url: profile, i_am: i_am };
        axios.post(`${config.apiUrl}/delete-users`, post_data)
          .then((response) => {
            if (response.status == 200) {
              alert("The user has been deleted successfully");
              location.reload();
            }
          })
          .catch((error) => {
            console.log("Error :", error)
          })

      },
      onCancel() { }
    });
  }


  const showModal = (uid, address) => {    
    setId(uid)
    setIsEditModalVisible(true);
  };

  const history = useHistory();
  

  const handleTableChange = (pagination, filters, sorter) => {
    console.log("Merchant pagination*******", pagination, filters, sorter);
    const { current, pageSize } = pagination;
    fetchData(current, pageSize, "Merchant", totalMerchantFetched, "");

  };
  
  let columns = [
    {
      title: 'Merchant Name',
      dataIndex: 'name',
    },
    {
      title: 'Email',
      dataIndex: 'email'
    },
    {
      title: 'Phone',
      dataIndex: 'phone'
    },
    {
      title: 'City',
      dataIndex: 'city',
    },
    {
      title: 'Edit',
      dataIndex: 'uid',
      render: (status, row, index) => <EditOutlined onClick={() => { showModal(row['uid'], row['address']) }} />
    },
    {
      title: 'Delete',
      dataIndex: 'uid',
      render: (status, row, index) => <DeleteOutlined onClick={() => { showDeleteModal(row['uid'], row['logo'], 'Merchant') }} />
    }
  ];

  return (
    <>

      <ProjectHeader >
        <PageHeader
          ghost
          title="Manage Merchants"
          buttons={[
            <Button onClick={openModal} type="primary" size="large">Create Merchant</Button>
          ]}
        />
      </ProjectHeader>

      <Main className='main-layout-div'>
        <Cards>
          <div className="table-responsive">

            <Table
              dataSource={userSearchData}
              columns={columns}
              pagination={paginationMerchant}
              onChange={handleTableChange}
            />
          </div>
        </Cards>
        <CreateMerchant onCancel={handleCancel} visible={isModalVisible} />

        {UId != null && <EditMerchant onCancel={handleCancel} visible={isEditModalVisible} Id={UId} />} 
      </Main>
    </>
  )
}

export default ManageMerchant
